module.exports = __webpack_public_path__ + "static/img/img-fj.79f856e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-fj.png
// module id = SJCh
// module chunks = 1